/**
 * Re-export of the shared {@link StringBuf} from `@utils/string-buf`.
 *
 * Kept as a thin alias so existing imports (`@excel/utils/string-buf`)
 * continue to work without churn.
 */

export { StringBuf } from "@utils/string-buf";
export type { StringBufOptions } from "@utils/string-buf";
